import {
  DriverLocations,
  DriverFuelAssignmentsCards,
  DriverFuelAssignment,
  GetFilteredDriverFuelAssignmentsFilter,
  GetDriverFuelAssignmentsFilter,
  FullDriverFuelAssignment,
  FuelTaskId,
  AddDriverFuelAssignmentForm
} from '../types';

import { PagedItems } from 'shared/types';

import { locatorServiceAPI } from 'shared/services';

export const driversAPI = {
  getDriverLocations: () => locatorServiceAPI.get<{ usersLocations: DriverLocations }>('usersLocation/currentLocations'),
  addDriverFuelAssignment: (form: AddDriverFuelAssignmentForm) => locatorServiceAPI.post<{}>('fueltasks', form),
  deleteDriverFuelAssignment: (fuelTaskId: DriverFuelAssignment['fuelTaskId']) => locatorServiceAPI.delete<{}>(`fueltasks/${fuelTaskId}`),
  getDriverFuelAssignments: ({
    pattern,
    pageSize,
    pageNumber
  }: GetDriverFuelAssignmentsFilter) => locatorServiceAPI.get<PagedItems<DriverFuelAssignment[]>>(`/fueltasks/search?pattern=${pattern}&pageSize=${pageSize}&pageNumber=${pageNumber}`),
  getDriverFuelAssignmentsCards: () => locatorServiceAPI.get<DriverFuelAssignmentsCards>('fueltasks/cards'),
  getDriverFuelAssignment: (fuelTaskId: FuelTaskId) => locatorServiceAPI.get<FullDriverFuelAssignment>(`/fueltasks/${fuelTaskId}`),
  getFilteredDriverFuelAssignments: (filter: GetFilteredDriverFuelAssignmentsFilter) => locatorServiceAPI.post<PagedItems<DriverFuelAssignment[]>>('fueltasks/filter', filter)
};
